export default {
  namespaced: true,

  state: () => ({
    auth_id: null,
    auth_role: null,
    token:  null,
    name: '',
    islogged: false,
  }),

  actions: {
    F_TOKEN(context,payload) {

      function b64DecodeUnicode(str) {
        return decodeURIComponent(
          atob(str).replace(/(.)/g, function (m, p) {
            var code = p.charCodeAt(0).toString(16).toUpperCase();
            if (code.length < 2) {
              code = "0" + code;
            }
            return "%" + code;
          })
        );
      }
      
      function base64_url_decode(str) {
        var output = str.replace(/-/g, "+").replace(/_/g, "/");
        switch (output.length % 4) {
          case 0:
            break;
          case 2:
            output += "==";
            break;
          case 3:
            output += "=";
            break;
          default:
            throw "Illegal base64url string!";
        }
      
        try {
          return b64DecodeUnicode(output);
        } catch (err) {
          return atob(output);
        }
      }


      return new Promise((resolve) => {       
        localStorage.setItem('Token', payload.token);
        localStorage.setItem('UserId', JSON.parse(base64_url_decode(payload.token.split('.')[1])).UserId);
        localStorage.setItem('RoleId', JSON.parse(base64_url_decode(payload.token.split('.')[1])).RoleId);
        localStorage.setItem('Name', JSON.parse(base64_url_decode(payload.token.split('.')[1])).Name);
        localStorage.setItem('UserName', JSON.parse(base64_url_decode(payload.token.split('.')[1])).UserName);
        localStorage.setItem('Email', JSON.parse(base64_url_decode(payload.token.split('.')[1])).Email);
        localStorage.setItem('CompanyId', JSON.parse(base64_url_decode(payload.token.split('.')[1])).CompanyId);
        localStorage.setItem('Initials', JSON.parse(base64_url_decode(payload.token.split('.')[1])).Initials);
        localStorage.setItem('LanguageId', JSON.parse(base64_url_decode(payload.token.split('.')[1])).LanguageId);
        localStorage.setItem('CountryId', JSON.parse(base64_url_decode(payload.token.split('.')[1])).CountryId);
        resolve();
      });
    },
  }
};